document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".ultra-top-collections__card");

  cards.forEach((card) => {
    card.addEventListener("mouseenter", () => {
      card.classList.add("is-hover");
    });

    card.addEventListener("mouseleave", () => {
      card.classList.remove("is-hover");
    });
  });
});